import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';
import Constants from '~/config/Constants';
import SlideTemplates from '~/config/SlideTemplates';
import NewSlideService from '~/services/NewSlideService';
import { createSpanInsidePTag } from './SlideV1Utils';
import Media from '~/models/Media';
import { isQuestionForPoll, isWordCloudQuestion } from './QuestionUtils';
import type { IBlock, Question } from 'shared-domains';

export function addNewAnswerExplanationSlide(explanation: IBlock, atIndex: number = -1) {
  const mathObject = {
    hasMath: explanation.hasMath,
    math: explanation.hasMath
      ? explanation.math
      : {
          latex: [],
          template: null,
        },
  };

  NewSlideService.addNewSlide(
    Constants.SlideTemplates.TITLE_TEXT_MEDIA,
    {
      title: {
        html: '<h1><strong><span style="font-size: 48px;">Explanation Slide...</span></strong></h1>',
      },
      subtitle: {
        html: !isEmpty(explanation.text)
          ? createSpanInsidePTag(explanation.text)
          : SlideTemplates.ShortText.data.html,
        ...mathObject,
      },
      media: explanation.media.length ? explanation.media[0] : Media(),
      atIndex: atIndex + 1,
    },
    true,
  );
}

export function doesQuestionHaveAnswerExplanations(question: Question) {
  const answerExplanation = question?.structure?.explain;

  if (!isPlainObject(answerExplanation)) {
    return false;
  }

  const hasText = !isEmpty(answerExplanation?.text);
  const hasMedia = !isEmpty(answerExplanation?.media);

  return hasText || hasMedia;
}

export function getQuestionDefaultMarks(question: Question) {
  if (
    get(question, 'structure.marks.correct', null) === null
    || get(question, 'structure.marks.correct', undefined) === undefined
    || get(question, 'structure.marks.correct', -1) < 0
  ) {
    return isQuestionForPoll(question) || isWordCloudQuestion(question) || isSlideForContent(question) ? 0 : 1;
  }

  if (isQuestionForPoll(question) || isSlideForContent(question)) {
    return 0;
  }

  return question?.structure?.marks?.correct;
}

export function getNewSlideFromExplanation(explanation: Record<string, any>) {
  const mathObject = {
    hasMath: explanation.hasMath,
    math: {
      latex: [],
      template: null,
    },
  };

  const slide = NewSlideService.createSlide(
    Constants.SlideTemplates.TITLE_TEXT_MEDIA,
    {
      title: {
        html: '<h1><strong><span style="font-size: 48px;">Explanation Slide...</span></strong></h1>',
      },
      subtitle: {
        html: !isEmpty(explanation.text)
          ? createSpanInsidePTag(explanation.text)
          : SlideTemplates.ShortText.data.html,
        ...mathObject,
      },
      media: explanation.media.length ? explanation.media[0] : Media(),
    },
  );

  return slide;
}

export function isSlideForContent(question: Record<string, any>) {
  if (!question) {
    return false;
  }
  const { type } = question;
  return [
    Constants.SlideTypes.CONTENT_SLIDE_V1,
    Constants.SlideTypes.CONTENT_SLIDE_V2,
  ].includes(type);
}
